import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './auth.service'; // Your authentication service

@Injectable({
    providedIn: 'root'
})
export class DialogManagerService {
    constructor(
        private readonly dialog: MatDialog,
        private readonly authService: AuthService
    ) {
        // Subscribe to logout events
        this.authService.logoutEvent.subscribe(() => {
            this.closeAllDialogs();
        });
    }

    closeAllDialogs(): void {
        this.dialog.closeAll();
    }
}